import type {
  AdminEngineItem,
  AdminEngineItemDTO,
} from '../types/review.types'

/**
 * ================================
 * 管理员引擎列表 item mapper
 *
 * 关键规则：
 * - displayTitle = title || name || "未命名引擎"
 * - cover = coverURL || image || ""
 * - description 为空时显示 "暂无简介"
 * ================================
 */
export function mapAdminEngineItem(dto: AdminEngineItemDTO): AdminEngineItem {
  const title = dto.title?.trim() || ''
  const name = dto.name?.trim() || ''
  const displayTitle = title || name || '未命名引擎'
  const description = dto.description?.trim() || '暂无简介'
  const cover = dto.coverURL?.trim() || dto.image?.trim() || ''

  return {
    id: dto.id,
    name: displayTitle,
    description,
    authorName: dto.author?.trim() || '未知作者',
    authorAvatarUrl: dto.authorAvatar ?? null,
    coverUrl: cover,
    createdAt: dto.createdAt ?? '',
    status: dto.status ?? 'unknown',
    updatedAt: dto.updatedAt,
    version: dto.version,
  }
}
